import { ApiCaller, ApiCallerOptions, ApiCallResult } from './restApiCaller';

export const createCallFetchWrapper = (fetchWrapper: any) => {
    return async <T = any>(options: ApiCallerOptions<T>): Promise<ApiCallResult<T>> => {
        const { url, method, headers = {}, data } = options;

        const config = {
            headers: {
                ...headers,
                'Content-Type': 'application/json' // always use application/json
            },
            body: data // fetch wrapper will serialize this if it is an object
        };

        // get the result
        const result = await fetchWrapper.request(method, url, config);

        // return the response
        return {
            status: result.status,
            headers: result.headers,
            data: result.data
        };
    };
};

export const buildApiCallerForFetchWrapper = (fetchWrapper: any): ApiCaller => {
    const call = createCallFetchWrapper(fetchWrapper);
    return {
        call,
        is4xxError: (errMsg: string) => errMsg.startsWith('Error: Request failed with status code 4'),
        is5xxError: (errMsg: string) => errMsg.startsWith('Error: Request failed with status code 5')
    };
};
